namespace GeniuzPOS.PosShift {
    export class PsTaxInvoiceDtColumns {
        static columnsKey = 'PosShift.PsTaxInvoiceDt';
    }
}
